import React, { useState } from "react";
import { DownloadBlueIcon } from "../../Icons/icons.component";
import { useEffect } from "react";
import DateRangeFilter from "./DateRangeFilter";
import { VERTICALS, VERTICAL_OPTIONS } from "../../../constants/app-constant";
import { useSelector, useDispatch } from "react-redux";
import { CONSTANTS } from "../../../constants/app-constant";
import Loader from "rsuite/Loader";
import { fetchInlineFilter } from "../../../actions/widget-action";
const { EMPTY_OBJECT } = CONSTANTS;

function WidgetFilters({
  widgets = [],
  onWidgetFiltered,
  downloadAll,
  widgetLoaded,
  isDownloading,
}) {
  const [feedType, setFeedType] = useState(-1);
  const [startRange, setStartRange] = useState(new Date());
  const [endRange, setEndRange] = useState(new Date());
  const dispatch = useDispatch();
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || EMPTY_OBJECT;

  useEffect(() => {
    console.log("WidgetFilters mounted with feedType:", feedType);
    filterWidgets();
  }, [feedType, endRange, startRange]);

  useEffect(() => {
    const { id } = selectedClient;
    if (id) {
      dispatch(
        fetchInlineFilter({
          client_id: id,
          to_date: endRange,
          from_date: startRange,
          media_type: VERTICALS.V_ONLINE,
        })
      );
    }
  }, [selectedClient, endRange, startRange, dispatch]);

  const canDownloadWidgets = () => {
    return (
      !!widgets.length && widgetLoaded.every((widget) => widget.loaded == true)
    );
  };

  const handleDateChange = (date, type) => {
    const formattedDate = date;
    if (type === "start") {
      setStartRange(formattedDate);
    } else {
      setEndRange(formattedDate);
    }
  };

  const filterWidgets = () => {

    let filteredWidgets = [...widgets];
    console.log(feedType,"line 65")
    if (feedType == "-1") {
      filteredWidgets = [...widgets];
    } else {
      console.log(feedType,"line 68")
      filteredWidgets = filteredWidgets.filter(
        (w) => w.type.toString() == feedType
      );
    }
    if (startRange || endRange) {
      filteredWidgets = filteredWidgets.map((w) => {
        return {
          ...w,
          from_date: new Date(startRange),
          to_date: new Date(endRange),
        };
      });
    }
    console.log("Filtered Widgets:", filteredWidgets);
    onWidgetFiltered && onWidgetFiltered(filteredWidgets);
  };

  return (
    <>
      <div className="titleRow">
        <div className="titleLeftWrap widgetFilterLeftWrap">
          <h2>Reports</h2>
          <select
            id="category"
            className="categoryDropdown"
            onChange={(e) => setFeedType(e.target.value)}
          >
            <option value="-1">All</option>
            {VERTICAL_OPTIONS.map(({ value, label }) => {
              return <option value={value}>{label}</option>;
            })}
          </select>
        </div>
        <div className="titleLeftWrap widgetFilterRightWrap">
          <div className="filterWrap d-flex">
            <DateRangeFilter
              handleDateChange={handleDateChange}
              startRange={startRange}
              endRange={endRange}
              showShortCut
              key="widget-filter"
              minDate={selectedClient ? selectedClient.start_date : null}
              maxDate={selectedClient ? selectedClient.end_date : null}
            />
            {isDownloading ? (
              <Loader className="donwlodAllBtn" />
            ) : (
              <button
                disabled={!canDownloadWidgets()}
                className="btn donwlodAllBtn"
                onClick={() =>
                  typeof downloadAll === "function" && downloadAll()
                }
              >
                <DownloadBlueIcon /> Download All
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default WidgetFilters;
